import { render, staticRenderFns } from "./routeDetails.vue?vue&type=template&id=49a2d336&"
import script from "./routeDetails.vue?vue&type=script&lang=js&"
export * from "./routeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports